import styled from "styled-components";
import { Breadcrumb as ANTDBreadcrumb} from "antd";

export const Breadcrumb = styled(ANTDBreadcrumb)`
    .ant-breadcrumb-link { 
        color: #6c7485;
    }
    
    .ant-breadcrumb a {
        color: #6c7485;
    }

    a:hover {
        color: rgba(0, 0, 0, 0.85);
    }
`;